import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackgroundGradient from "@/components/landing/BackgroundGradient";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import ContactModal from "@/components/landing/ContactModal";
import WorkflowSection from "@/components/landing/WorkflowSection";
import SEO from "@/components/SEO";

export default function ServicesPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <SEO title="Web Design, SEO & GEO Services — Dyna Agency" description="Full-service web design, SEO, GEO and AI search optimization for local businesses in Israel and the US. Custom built, ranked, and managed by Dyna Agency." path="/services" />
      <BackgroundGradient />
      <div style={{ minHeight: "100vh", color: "var(--dyna-fg)", position: "relative", zIndex: 1 }}>
        <Navbar onCTA={() => setModalOpen(true)} activePage="services" />
        <main style={{ paddingTop: 120 }}>
          {/* Page hero */}
          <section style={{ padding: "var(--s-xl) var(--site-px) var(--s-lg)", maxWidth: "var(--site-max)", margin: "0 auto" }}>
            <span className="eyebrow" style={{ display: "block", marginBottom: 8 }}>{t("pages.services.eyebrow")}</span>
            <h1 style={{
              fontFamily: "Coolvetica, system-ui, sans-serif",
              fontSize: "clamp(48px, 7vw, 80px)", fontWeight: 700,
              letterSpacing: "0.05em", textTransform: "uppercase",
              margin: "0 0 20px", lineHeight: 1.05,
            }}>
              {t("pages.services.title")}
            </h1>
            <p style={{
              fontFamily: "Geist, system-ui, sans-serif", fontWeight: 300,
              fontSize: 18, lineHeight: 1.7, color: "var(--dyna-fg-muted)", maxWidth: 560,
            }}>
              {t("pages.services.subtitle")}
            </p>
          </section>

          {/* WorkflowSection (services + process) */}
          <WorkflowSection onCTA={() => setModalOpen(true)} />

          {/* Why DYNA */}
          <section style={{ padding: "var(--s-xl) var(--site-px)", maxWidth: "var(--site-max)", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <span className="eyebrow" style={{ display: "block", marginBottom: 8, color: "var(--color-secondary, var(--lavender-500))" }}>
                {t("pages.services.whyEyebrow")}
              </span>
              <h2 style={{
                fontFamily: "Coolvetica, system-ui, sans-serif",
                fontSize: "clamp(32px, 4vw, 48px)", fontWeight: 700,
                letterSpacing: "0.05em", textTransform: "uppercase",
                lineHeight: 1.1, margin: "0 0 12px", color: "var(--dyna-fg)",
              }}>
                {t("pages.services.whyTitle")}
              </h2>
              <p style={{
                fontFamily: "Geist, system-ui, sans-serif", fontWeight: 300,
                fontSize: 18, lineHeight: 1.7, color: "var(--dyna-fg-muted)",
                maxWidth: 480, margin: "0 auto",
              }}>
                {t("pages.services.whySubtitle")}
              </p>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 24 }}>
              {[
                { title: t("pages.services.values.designTitle"),  body: t("pages.services.values.designBody"),  icon: "✦" },
                { title: t("pages.services.values.lastingTitle"), body: t("pages.services.values.lastingBody"), icon: "◈" },
                { title: t("pages.services.values.fastTitle"),    body: t("pages.services.values.fastBody"),    icon: "◎" },
                { title: t("pages.services.values.careTitle"),    body: t("pages.services.values.careBody"),    icon: "◇" },
              ].map((v) => (
                <div key={v.title} style={{
                  padding: "32px 28px", borderRadius: 20,
                  border: "1px solid var(--dyna-border)",
                  background: "var(--dyna-bg-elevated)",
                }}>
                  <span style={{ fontSize: 24, display: "block", marginBottom: 16, color: "var(--lavender-500)" }}>{v.icon}</span>
                  <h3 style={{
                    fontFamily: "Coolvetica, system-ui, sans-serif",
                    fontSize: 22, fontWeight: 700, letterSpacing: "0.04em",
                    textTransform: "uppercase", color: "var(--dyna-fg)",
                    margin: "0 0 10px",
                  }}>
                    {v.title}
                  </h3>
                  <p style={{ fontSize: 15, lineHeight: 1.6, color: "var(--dyna-fg-muted)", margin: 0 }}>
                    {v.body}
                  </p>
                </div>
              ))}
            </div>
          </section>
        </main>
        <Footer />
      </div>
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
